'use client';

import { ConfigService } from '@nextgen-web-framework/core';
import { PageLoader } from '@commerce-webcomponents/ui';

const Loading = () => {
  const configs = ConfigService?.getConfigs?.() || {};
  const enableAppRouterLoading = configs.NEXT_PUBLIC_ENABLE_APP_ROUTER_LOADING as boolean;

  if (!enableAppRouterLoading) {
    return null;
  }
  return <PageLoader />;
};

export default Loading;
